import {
  pullRequestFilesChangedCommitPath,
  pullRequestFilesChangedCommitRangePath,
  pullRequestFilesChangedPath,
} from '@github-ui/paths'
import {CommitsDropdown, type CommitsDropdownProps} from './CommitsDropdown'
import type {FileTreePayload} from '../../page-data/payloads/file-tree'

export type ChangesSelectorProps = Pick<FileTreePayload, 'ownerLogin' | 'repositoryName' | 'pullRequestNumber'> &
  Pick<CommitsDropdownProps, 'lastReviewOid' | 'commits' | 'variant'>

export function ChangesSelector({
  ownerLogin,
  repositoryName,
  pullRequestNumber,
  commits,
  lastReviewOid,
  variant,
}: ChangesSelectorProps) {
  const onRangeUpdated = (args: {singleOrStartOid: string; endOid?: string} | undefined) => {
    let path: string
    if (!args) {
      path = pullRequestFilesChangedPath({owner: ownerLogin, repo: repositoryName, number: pullRequestNumber})
    } else if (args.endOid) {
      path = pullRequestFilesChangedCommitRangePath({
        owner: ownerLogin,
        repo: repositoryName,
        number: pullRequestNumber,
        base: args.singleOrStartOid,
        head: args.endOid,
      })
    } else {
      path = pullRequestFilesChangedCommitPath({
        owner: ownerLogin,
        repo: repositoryName,
        number: pullRequestNumber,
        commit: args.singleOrStartOid,
      })
    }

    window.location.href = path
  }

  return (
    <CommitsDropdown
      commits={commits}
      lastReviewOid={lastReviewOid}
      onRangeUpdated={onRangeUpdated}
      variant={variant}
    />
  )
}

try{ ChangesSelector.displayName ||= 'ChangesSelector' } catch {}